import * as angular from 'angular';


export class AncillariesThirdPartiesTransformer {
    constructor (

    ) {}

    generateThirdPartyCompanies = (thirdPartyCompanies: any, cachedData: any) => {
        const data = [];
        for (let i = 0; i < thirdPartyCompanies.thirdPartyCompanies.length; i++) {
            data.push({
                title: thirdPartyCompanies.thirdPartyCompanies[i].message,
                description: 'MMB_RES_COMPANY',
                externalUrl: thirdPartyCompanies.thirdPartyCompanies[i].externalUrl,
                segmentsIds: thirdPartyCompanies.thirdPartyCompanies[i].segmentIds,
                segments: []
            });
        }
        for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < data[i].segmentsIds.length; j++) {
                for (let k = 0; k < cachedData.order.slices.length; k++) {
                    for (let l = 0; l < cachedData.order.slices[k].segments.length; l++) {
                        if (data[i].segmentsIds[j] === cachedData.order.slices[k].segments[l].id) {
                            data[i].segments.push(cachedData.order.slices[k].segments[l]);
                        }
                    }

                }

            }
        }
        return data;
    };
}

AncillariesThirdPartiesTransformer.$inject = [];
try {
    const mod = angular.module('ib-web-ancillaries-module');
    mod.service('AncillariesThirdPartiesTransformer', AncillariesThirdPartiesTransformer);
} catch (error) {
    const mod = angular.module('ib-web-ancillaries-module', []);
    mod.service('AncillariesThirdPartiesTransformer', AncillariesThirdPartiesTransformer);
}
